// extracted by mini-css-extract-plugin
export default {"fileUploadForm":"style_fileUploadForm__AjHTD","modalFooter":"style_modalFooter__A7CIa"};